// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Vk-z","tupacHeader":"Wk-z","tupacHeader2":"Xk-z","tupacMenu":"Yk-z","tupacMenu2":"Zk-z","tupacMain":"_k-z","tupacMain2":"al-z"};